// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_jkB-8","after-pay-info":"after-pay-info_gMupP","msg":"msg_xlC-t","title-img":"title-img_3ivfz","sub-title":"sub-title_45b3P"};